import { Injectable } from '@angular/core';
import { IMqttMessage, IMqttServiceOptions, MqttService } from 'ngx-mqtt';
import { RealtimeService } from '../realtime.service';

@Injectable({
    providedIn: 'root',
})
export class MqttRtService {
  
  private topic!: string;
  private mqttService!: MqttService;

  constructor(private realTimeService:RealtimeService) {}

  init() {
    const user = this.getCurrentUser();
    if (!user) return;

    this.topic ="/RIMTRACK/RT/"+user.id;
    let conf: IMqttServiceOptions = {
        username: 'in',
        password: 'in',
        url: 'wss://preprod.rimtrack.com/mqtt',
    };
    if (!(window.location.host.startsWith('127.0.0.1') ||window.location.host.startsWith('localhost')))
            conf.url = window.location.protocol.replace('http', 'ws') +'//' + window.location.host.replace('www.', '') + '/mqtt';
        conf.password = 'any';
        conf.username = user.token;        

        this.mqttService = new MqttService(conf);


    this.mqttService.onConnect.subscribe(() => {
      console.log('MQTT Connected');
      this.subscribeMessages();
    });

    this.mqttService.onError.subscribe(err => {
      console.error('MQTT error:', err);
    });
  }

  private subscribeMessages() {
    this.mqttService.observe(this.topic).subscribe((msg: IMqttMessage) => {
      const payload = JSON.parse(msg.payload.toString());      
      this.realTimeService.prepareRealTimeRecordMqtt(payload)
    });
  }

  private getCurrentUser() {
    const u = localStorage.getItem("currentUser");
    return u ? JSON.parse(u) : null;
  }   
}


